// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZrvZ3","level2":"styles_level2__Bfyp3","closeButton":"styles_closeButton__v4FuY"};